import { render, staticRenderFns } from "./McpTokens.vue?vue&type=template&id=123ef9d8&"
import script from "./McpTokens.vue?vue&type=script&lang=js&"
export * from "./McpTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports